import { ButtonHTMLAttributes, ReactNode } from "react";
import { Container } from "./styles";

interface SecondaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  loading?: boolean;
  icon?: ReactNode;
  children?: ReactNode;
  variant?: "default" | "danger";
}

export function SecondaryButton({
  text,
  loading = false,
  icon,
  children,
  variant = "default",
  ...rest
}: SecondaryButtonProps) {
  return (
    <Container disabled={loading} variant={variant} {...rest}>
      {loading ? (
        <div className="loading" />
      ) : (
        <>
          {icon}
          {text || children}
        </>
      )}
    </Container>
  );
}
